import React from "react";
import styled from "styled-components";
import { Table as BsTable } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { RUTA_SERVICIOS_TRANSPORTE } from "../../../services/rutas";
import { ItemListadoServiciosTransporte } from "../../../services/transporteServicios";


function Table({ items, puedeEditar }: TableSectionProps) {
    return (
        <StyledTable responsive hover>
            <thead>
                <tr>
                    <StyledColHeader>Nombre</StyledColHeader>
                    <StyledColHeader>Sector</StyledColHeader>
                    <StyledColHeader>Precio</StyledColHeader>
                    <StyledColHeader>Descripción</StyledColHeader>
                </tr>
            </thead>
            <tbody>
                {
                    items.map((_, index) => <TableItem key={_.id} item={_} puedeEditar={puedeEditar}/>)
                }
            </tbody>
        </StyledTable>
    );
}

interface TableSectionProps {
    items: ItemListadoServiciosTransporte[];
    puedeEditar: boolean;
}

interface TableItemProps {
    item: ItemListadoServiciosTransporte;
    puedeEditar: boolean;
}

function TableItem({ item, puedeEditar }: TableItemProps){
    let navigate = useNavigate();
    const currencyFormat = new Intl.NumberFormat('es-CO', currencyFormatOptions);

    const onRowClick = () => {
      if (!puedeEditar) return;
      navigate(`${RUTA_SERVICIOS_TRANSPORTE}/${item.id}`, { replace: false });
    };

    return (
        <StyledRow onClick={onRowClick} $clickable={puedeEditar}>
            <StyledCell>{item.nombre}</StyledCell>
            <StyledCell>{item.nombreSector}</StyledCell>
            <StyledCell>{currencyFormat.format(item.precio)}</StyledCell>
            <StyledCell>{item.descripcion}</StyledCell>
        </StyledRow>
    );
}

const currencyFormatOptions: any = { style: 'currency', currency: 'COP' }

const StyledTable = styled(BsTable)`

`

const StyledCell = styled("td")`

`

const StyledColHeader = styled("th")`
    color: ${props => props.theme.colors.main};
`

const StyledRow = styled("tr")<{ $clickable?: boolean }>`
    cursor: ${props => props.$clickable ? "pointer" : "default"};
`

export default Table;